import React, { useState, useEffect } from "react";  // Make sure to include useEffect


const pensionMarathiInp = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  

  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
        <h3>Employee Details in Marathi</h3>

        <label>
         Full Name of the Employee: (in Marathi)
        <input type="text" name="employeeNameMar" value={formData.employeeNameMar} onChange={handleInputChange} />
        </label>

        <label>
         Name of the Institution: (in Marathi)
        <input type="text" name="institutionNameMar" value={formData.institutionNameMar} onChange={handleInputChange} />
        </label>
        
        <label>
         Designation: (in Marathi)
        <input type="text" name="designationMar" value={formData.designationMar} onChange={handleInputChange} />
        </label>
        
        <label>
        Name of the Region: (in Marathi)
        <input type="text" name="regionMar" value={formData.regionMar} onChange={handleInputChange} />
        </label>

        <label>
        Place of the Regional Office: (in Marathi)
        <input type="text" name="regionalPlaceMar" value={formData.regionalPlaceMar} onChange={handleInputChange} />
        </label>

      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default pensionMarathiInp;
